var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup31(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_31",
    "data-name": "Group 31",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.102,
    height: 35.101,
    viewBox: "0 0 35.102 35.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M6038.507,96.362a17.55,17.55,0,1,1,17.55-17.55A17.571,17.571,0,0,1,6038.507,96.362Zm0-33.912a16.362,16.362,0,1,0,16.361,16.362A16.381,16.381,0,0,0,6038.507,62.45Z",
    transform: "translate(-6020.956 -61.261)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(9.073 11.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M6043.834,74.351c.006.149.009.3.009.451a9.911,9.911,0,0,1-15.256,8.35,7.09,7.09,0,0,0,.831.048,6.983,6.983,0,0,0,4.327-1.492,3.485,3.485,0,0,1-3.254-2.418,3.5,3.5,0,0,0,.656.061,3.385,3.385,0,0,0,.917-.122,3.484,3.484,0,0,1-2.8-3.417v-.043a3.481,3.481,0,0,0,1.579.435,3.492,3.492,0,0,1-1.079-4.653,9.894,9.894,0,0,0,7.184,3.64,3.486,3.486,0,0,1,5.937-3.178,6.941,6.941,0,0,0,2.214-.844,3.492,3.492,0,0,1-1.531,1.927,6.973,6.973,0,0,0,2-.548A7.1,7.1,0,0,1,6043.834,74.351Z",
    transform: "translate(-6028.587 -70.913)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup31);
export default __webpack_public_path__ + "static/media/Group 31.7e28ede8502fc5f33da49f7feeaf68ac.svg";
export { ForwardRef as ReactComponent };